import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import { useTranslation } from '../../src/i18n';
import TextButton from '../TextButton';
import { TP } from '../../constants/consts';
import HubspotFormsModal from '../HubspotFormsModal';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: 300,
  },
  improveRow: {
    marginTop: 5,
    padding: 10,
    backgroundColor: 'rgba(243, 109, 42, 0.1)',
    lineHeight: 1,
    fontFamily: 'Roboto',
    fontSize: 14,
  },
  text: {
    marginRight: 5,
  },
  improveBtn: {
    marginTop: -2,
    '& span': {
      lineHeight: 1,
    },
  },
  hbsptForm: {
    margin: 20,
  },
}));

const ActionsBlock = ({ showImproveText, canPrint }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [hubspotModalOpen, setHubspotModalOpen] = useState(false);

  const onImproveClick = () => {
    setHubspotModalOpen(true);
  };

  const onModalClose = () => {
    setHubspotModalOpen(false);
  };

  const onHubspotFormReady = form => {
    const currenturl = window.location.href;
    const pathArray = window.location.pathname.split('/');
    const [language] = pathArray.slice(-1);
    const urlInput = form.querySelector("input[name='update_profile_page_url']");
    const lngInput = form.querySelector("input[name='profile_update_language']");
    urlInput.value = currenturl;
    lngInput.value = language;
    form.querySelector('.hs_update_profile_page_url').hidden = true;
    form.querySelector('.hs_profile_update_language').hidden = true;
    urlInput.dispatchEvent(new Event('input', { bubbles: true }));
    lngInput.dispatchEvent(new Event('input', { bubbles: true }));
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1} justify="flex-end">
        {canPrint && (
          <Grid item>
            <IconButton size="small" aria-label="print">
              <PrintIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>

      {showImproveText && (
        <div className={classes.improveRow}>
          <span className={classes.text}>{t(`${TP}.HELP_US_IMPROVE_PRODUCTION`)}</span>
          <TextButton onClick={onImproveClick} className={classes.improveBtn}>
            {t(`${TP}.m_ARTICLES_CLICK_HERE`)}
          </TextButton>
        </div>
      )}
      <HubspotFormsModal
        portalId="6012578"
        formId="6883c5bb-25e8-45eb-bac1-6a23059b0268"
        isOpen={hubspotModalOpen}
        onClose={onModalClose}
        onFormReady={onHubspotFormReady}
      />
    </div>
  );
};

ActionsBlock.propTypes = {
  canPrint: PropTypes.bool,
  showImproveText: PropTypes.bool,
};

ActionsBlock.defaultProps = {
  canPrint: false,
  showImproveText: true,
};

export default ActionsBlock;
